var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep76(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 33,
    viewBox: "0 0 260 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 30.1705C8.31659 30.561 7.68342 30.561 7.2929 30.1705L0.928934 23.8065C0.538409 23.416 0.538409 22.7829 0.928934 22.3923C1.31946 22.0018 1.95262 22.0018 2.34315 22.3923L8 28.0492L13.6569 22.3923C14.0474 22.0018 14.6805 22.0018 15.0711 22.3923C15.4616 22.7828 15.4616 23.416 15.0711 23.8065L8.70711 30.1705ZM249 2L18 2.00002L18 2.2014e-05L249 1.81929e-06L249 2ZM9 11L9 29.4634L7 29.4634L7 11L9 11ZM260 11L260 33L258 33L258 11L260 11ZM18 2.00002C13.0294 2.00002 9 6.02946 9 11L7 11C7 4.92489 11.9249 2.25451e-05 18 2.2014e-05L18 2.00002ZM249 1.81929e-06C255.075 1.28819e-06 260 4.92487 260 11L258 11C258 6.02944 253.971 2 249 2L249 1.81929e-06Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep76);
export default __webpack_public_path__ + "static/media/laptop_step_7_6.016b33d7659caecc36b9534d1a98fe01.svg";
export { ForwardRef as ReactComponent };